function Wishlist() {}
Wishlist.prototype.initAddToWishList = function(items) {
    var ajax = new Ajax();
    var self = this;
    if ($('.grid__item .contact-form').length === 0) {
        return;
    }
    var selector = $('.contact-form .nt-wishlist');
    if (items) {
        var arrayItem = [];
        items.forEach(function(item) {
            arrayItem.push($(item).find('.contact-form .nt-wishlist')[0]);
        });
        selector = arrayItem;
    }
    $(selector).click(function(event) {
        var form = $(this).closest('form');
        var name = '';
        if ($('.product-single').length > 0) {
            name = $(this).parents('.nt-product-content').find('.nt-product-page-top h1').html();
        } else {
            name = $(this).parents('.nt-grid-item-inner').find('.nt-product-item-name a').html();
        }
        ajaxAddToWishList(form, this, name);
        event.preventDefault();
        return false;
    });

    function ajaxAddToWishList(form, ele, name) {
        $.ajax({
            type: "post",
            url: "/contact",
            data: form.serialize(),
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(msg) {
                toastr.success('<span style="font-weight:bold">' + name + '</span>' + 'was successfully added to your' + '<a href="/pages/wishlists">' + 'Wishlist' + '</a>!');
                var productId = $(ele).attr('data-id');
                $('.wishlist-' + productId).addClass('checked-wishlist');
                Ajax.hideLoading();
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t add to wishlist!');
                Ajax.hideLoading();
            }
        });
    };
}
Wishlist.prototype.initRemoveToWishList = function() {
    var ajax = new Ajax();
    var self = this;
    $('.contact-form .remove-wishlist').click(function(event) {
        var form = $(this).closest('form');
        var item = $(this).parents('.item');
        var name = item.find('.product-title').html();
        ajaxRemoveToWishList(form, item, name);
        event.preventDefault();
        return false;
    });

    function ajaxRemoveToWishList(form, item, name) {
        $.ajax({
            type: "post",
            url: "/contact",
            data: form.serialize(),
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(msg) {
                toastr.success('<span style="font-weight:bold">' + name + '</span>' + 'Can&#39;t add to wishlist!');
                var currentTable = $('.nt-wishlist-page');
                var newTable = $(msg).find('.nt-wishlist-page');
                currentTable.replaceWith(newTable);
                self.initRemoveToWishList();
                Ajax.hideLoading();
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t add to wishlist!');
                Ajax.hideLoading();
            }
        });
    };
}
